import { api } from "@/lib/api";
import { toast } from "sonner";
import { Download, CheckCircle2, Star } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export function FlyerLibrary({ flyers, currentUrl, onChange }) {
  if (!flyers?.length) return null;
  const use = async (f) => {
    try { await api.post(`/admin/flyers/${f.id}/use`); toast.success(`"${f.title}" is now on the home page and footer`); onChange(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not switch flyer"); }
  };
  return (
    <div className="dg-card rounded-xl p-5" data-testid="flyer-library">
      <div className="dg-eyebrow flex items-center gap-1"><Star className="w-3 h-3" /> Flyer library — all with the correct email (David@docdrgadget.com)</div>
      <p className="text-sm text-slate-400 mt-1">Download any of them for printing or posting. The one marked "On the site" shows at the top of the home page and in the footer.</p>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {flyers.map((f) => {
          const active = f.url === currentUrl;
          return (
            <div key={f.id} className={`rounded-xl border p-3 flex flex-col gap-3 ${active ? "border-cyan-400/60 bg-cyan-500/5" : "border-slate-800"}`} data-testid={`flyer-item-${f.id}`}>
              <img src={`${BASE}${f.url}`} alt={f.title} className="w-full rounded-lg object-contain bg-slate-900 max-h-64" />
              <div className="text-xs text-slate-300 leading-snug">{f.title}</div>
              <div className="mt-auto flex flex-wrap gap-2">
                <a href={`${BASE}${f.download || f.url}`} download={`Dr.Gadget-flyer-${f.id}.png`} className="dg-btn-ghost rounded-full px-3 py-1.5 text-xs flex items-center gap-1" data-testid={`flyer-download-${f.id}`}>
                  <Download className="w-3 h-3" /> Download
                </a>
                {active ? <span className="dg-chip flex items-center gap-1" data-testid={`flyer-active-${f.id}`}><CheckCircle2 className="w-3 h-3" /> On the site</span>
                        : <button type="button" onClick={() => use(f)} className="dg-btn-primary rounded-full px-3 py-1.5 text-xs" data-testid={`flyer-use-${f.id}`}>Use on site</button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
